export default __webpack_public_path__ + "static/media/zodic-luck-number.360565ee.jpg";